/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useEffect, useState } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isStringNotEmpty } from "cms/utils/empty-exists";
import { Logger } from "cms/utils/logger";
import { TextLink } from "cms/link/text-link";
import { formatDate } from "cms/utils/format-date";
import { ReactComponent as CalendarIcon } from "cms/assets/icons/calendar-alt.svg";

const CardsItem = (props) => {

    const { item, style } = props;
    const {
        date = "",
        description = "",
        heading = "",
        image: image_guid = "",
        link: link_guid = ""
    } = item || {};

    const { token } = useAuth();
    const [image, setImage] = useState();
    const [link, setLink] = useState();

    useEffect(() => {
        const fetchData = async () => {
            Logger.debug(`load image ${image_guid}`);
            if (!image) {
                if (image_guid) {
                    const img = await SimpliCitySDK.images.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (!link) {
                if (link_guid) {
                    const _link = await SimpliCitySDK.link.findOne(token, link_guid);
                    setLink(_link);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={"cards-item"} style={style}>

            {image &&
                <div className='cards-image-wrapper'>
                    <img alt={image.alt} src={image.url} />
                </div>
            }

            <div className='cards-item-content'>
                <div className='cards-item-text-content'>
                    {date &&
                        <div className='cards-date'>
                            <CalendarIcon alt='calendar' />
                            {formatDate(new Date(date), "MMMM D, YYYY")}
                        </div>
                    }

                    {isStringNotEmpty(heading) &&
                        <h5>{heading}</h5>
                    }

                    {isStringNotEmpty(description) &&
                        <p>{description}</p>
                    }
                </div>

                {link && <TextLink link={link} />}

            </div>
        </div>
    );
};

export { CardsItem };
